//v1.0.0
//jquery transition
//Also implements fastdom to split read/write operations

import fastdom from 'fastdom';

export class DOMHelper {
	public innerHeight: number;
	public innerWidth: number;
	public scrollY: number;

	constructor() {
		this._measureCore();
	}

	public setAttribute(element: Element, name: string, value: string): void {
		element.setAttribute(name, value);
	}

	public removeAttributte(element: Element, name: string): void {
		element.removeAttribute(name);
	}

	public getAttribute(element: Element | EventTarget, attrName: string): string {
		if (!element || !attrName) {
			return;
		}
		return (element as Element).getAttribute(attrName);
	}

	public getAttributes(element: Element | EventTarget): any {
		if (!element) {
			return;
		}

		let attr = {};
		for (let i = 0; i < (element as Element).attributes.length; i++) {
			attr[(element as Element).attributes[i].name] = (element as Element).attributes[i].value;
		}
		return attr;
	}

	//Set config to
	//TODO - should be a standard Rectangle or Size class
	public resize(rect: any): void {
		this.innerHeight = rect.width;
		this.innerWidth = rect.height;
	}

	public scroll(y: number): void {
		this.scrollY = y;
	}

	public setHTML(element: HTMLElement, html: string, complete: Function = null): void {
		if (!element || !html) {
			return;
		}

		fastdom.mutate(() => {
			element.innerHTML = html;
			if (complete) {
				complete();
			}
		});
	}

	public setText(element: HTMLElement, text: string): void {
		if (!element || !text) {
			return;
		}

		fastdom.mutate(() => {
			element.innerText = text;
		});
	}

	public append(
		element: HTMLElement | Element,
		addElement: HTMLElement | string,
		complete: Function = null,
		before: boolean = false
	): void {
		if (!addElement) {
			return;
		}

		if (typeof addElement === 'string') {
			fastdom.mutate(() => {
				let location: InsertPosition = before ? 'afterbegin' : 'beforeend';
				element.insertAdjacentHTML(location, addElement as string);
				if (complete) {
					complete();
				}
			});
		} else {
			fastdom.mutate(() => {
				if (before) {
					element.insertBefore(addElement as HTMLElement, element.firstChild);
				} else {
					element.appendChild(addElement as HTMLElement);
				}

				if (complete) {
					complete();
				}
			});
		}
	}

	public removeElement(element: HTMLElement | Element, complete: Function = null): void {
		if (!element) {
			return;
		}

		fastdom.mutate(() => {
			element.parentNode.removeChild(element);
			if (complete) {
				complete();
			}
		});
	}

	public addClass(element: HTMLElement | Element, className: string) {
		if (!element) {
			console.log('Null element set.');
			return;
		}

		fastdom.mutate(() => {
			if (element.classList) {
				element.classList.add(className);
			} else {
				element.className += ' ' + className;
			}
		});
	}

	public removeClass(element: HTMLElement | Element, className: string) {
		if (!element || !className || className === '') {
			return;
		}

		fastdom.mutate(() => {
			if (element.classList) {
				element.classList.remove(className);
			} else {
				element.className = element.className.replace(' ' + className, '');
			}
		});
	}

	public toggleClass(element: HTMLElement | Element, className: string, add: boolean = true) {
		if (!element || !className || className === '') {
			return;
		}

		if (add) {
			this.addClass(element, className);
		} else {
			this.removeClass(element, className);
		}
	}

	public que(callback: Function): any {
		return fastdom.mutate(() => {
			callback();
		});
	}

	public clearQue(id: any): void {
		fastdom.clear(id);
	}

	public hasClass(element: HTMLElement | Element, className: string): boolean {
		return element.classList.contains(className);
	}

	public parent(element: HTMLElement | Element): Node {
		return element.parentNode;
	}

	public contains(element: HTMLElement | Element, scope: HTMLElement | Element = null): boolean {
		if (scope === null) {
			scope = document.body;
		}

		return scope.contains(element);
	}

	public sizes(element: HTMLElement | Element, callback: Function): void {
		fastdom.measure(() => {
			var rect: ClientRect = element.getBoundingClientRect();
			callback({
				position: { left: (element as HTMLElement).offsetLeft, top: (element as HTMLElement).offsetTop },
				rect: rect,
				width: rect.width,
				height: rect.height
			});
		});
	}

	private _measureCore(): void {
		fastdom.measure(() => {
			this.innerHeight = window.innerHeight;
			this.innerWidth = window.innerWidth;
		});
	}
}
